module.exports = __webpack_public_path__ + "static/media/rainbow-white-confetti.b87be2e7.jpg";